import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { CalendlyCallie } from '@calendly/ui/components/glyphs/CalendlyCallie'
import { Header, Popup } from '@calendly/ui/components/popup'
import { SwitchInput } from '@calendly/ui/components/switch-input'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { gradientIconAI } from '@calendly/ui/theme'
import classNames from 'classnames'
import { useState } from 'react'

import {
  defaultOnBodyCss,
  defaultOnDescriptionCss,
  defaultOnDialogContentCss,
  defaultOnInformationCopyCss,
  defaultOnInformationCss,
  optInButtonCss,
  optInEyebrowCss,
  optInFooterCss,
  optInHeaderCopyCss,
  optInTitleCss,
  popupSurfaceCss,
  switchCallieMarkCss,
  switchHandleCss,
  switchHandleEnabledCss,
  switchVisualCss,
  switchVisualDisabledCss,
  switchVisualEnabledCss,
  switchWrapperCss
} from './styles'
import type { ExperienceProps } from './types'

export const DefaultOnModal = ({ isLoading, onSave }: ExperienceProps) => {
  const [isCallieEnabled, setIsCallieEnabled] = useState(true)
  const switchLabel = I18n.t('publisher.growth_experiments.callie_intro_entry_points.default_on.switch_label')

  return (
    <Popup isBlocking onClose={() => {}} size="max-content">
      <div className={classNames(popupSurfaceCss, defaultOnDialogContentCss)}>
        <Header>
          <div className={optInHeaderCopyCss}>
            <p className={optInEyebrowCss}>
              {I18n.t('publisher.growth_experiments.callie_intro_entry_points.eyebrow')}
            </p>
            <h2 className={optInTitleCss}>
              {I18n.t('publisher.growth_experiments.callie_intro_entry_points.default_on.title')}
            </h2>
          </div>
        </Header>
        <div className={defaultOnBodyCss}>
          <p className={defaultOnDescriptionCss}>
            {I18n.t('publisher.growth_experiments.callie_intro_entry_points.default_on.description')}
          </p>
          <label className={defaultOnInformationCss}>
            <span className={defaultOnInformationCopyCss}>
              {I18n.t('publisher.growth_experiments.callie_intro_entry_points.default_on.information')}
            </span>
            <span className={switchWrapperCss}>
              <SwitchInput
                aria-label={switchLabel}
                checked={isCallieEnabled}
                disabled={isLoading}
                onChange={(event) => setIsCallieEnabled(event.currentTarget.checked)}
              />
              <span
                aria-hidden
                className={classNames(switchVisualCss, {
                  [switchVisualEnabledCss]: isCallieEnabled,
                  [switchVisualDisabledCss]: isLoading
                })}
              >
                <span
                  className={classNames(switchHandleCss, {
                    [switchHandleEnabledCss]: isCallieEnabled
                  })}
                >
                  {isCallieEnabled && (
                    <span className={switchCallieMarkCss} data-testid="callie-switch-mark">
                      <UiIcon icon={CalendlyCallie} color={gradientIconAI} size="small" title="" />
                    </span>
                  )}
                </span>
              </span>
            </span>
          </label>
        </div>
        <div className={optInFooterCss}>
          <Button
            className={optInButtonCss}
            data-testid="callie-primary-action"
            disabled={isLoading}
            loading={isLoading}
            onClick={() => onSave({ response: isCallieEnabled ? 'opted_in' : 'opted_out' }, isCallieEnabled)}
          >
            {I18n.t('publisher.growth_experiments.callie_intro_entry_points.continue')}
          </Button>
        </div>
      </div>
    </Popup>
  )
}
